import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import configApp from '../../config/config-app';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/governanceroom/clientscitiesmanagers/';
    const pathsList = {
        pathAdd: pathFrontEnd+'add',
        pathEdit: pathFrontEnd+'edit',
        pathView: pathFrontEnd+'view',
        endpoint: config.endpoints.backend+'governanceroom/clientscitiesmanagers/getall',
        endpointDelete: `${config.endpoints.backend}governanceroom/clientscitiesmanagers/delete`
    }

    let hiddenValues = {...profileFilter, application_profile_id: configApp.default_foreign_key.sdg_profiles.cityManager}
    
    const list = {
        labelTitle: 'Lista de Gestores de Municípios',
        labelTitleButtonAdd: 'Incluir novo gestor de município',
        fieldsShowOnDelete: ['name'],
        filter: hiddenValues,
        showPrintButtons: true,
        canDelete: true,
        columns: [
            {
                name: 'city_manager_name',
                label: 'Nome'
            },            
            {
                name: 'instance_name',
                label: 'Cliente'
            },
            {
                name: 'geo_city_name',
                label: 'Município'
            },
            {
                name: 'status_name',
                label: 'Status'
            }
        ],  
        ...pathsList 
    };    

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;
